import { useContext } from "react";
import { I18nContext } from "../../context/i18nContext";
export const useI18n = () => {
    const i18n = useContext(I18nContext);
    return {
        translate: (...args) => i18n.t(...args),
        format: (...args) => i18n.f(...args),
    };
};
